import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthProviderLocationSupportAccredited,
	GetHealthProviderLocationSupportAccreditedModel,
	GetHealthProviderLocationSupportAccreditedParams,
} from 'domain/usecases/private/booking-flow/health/get-health-provider-location-support-accredited';

export class RemoteGetHealthProviderLocationSupportAccredited implements GetHealthProviderLocationSupportAccredited {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthProviderLocationSupportAccreditedModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthProviderLocationSupportAccreditedParams): Promise<GetHealthProviderLocationSupportAccreditedModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
